import React, {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from "react";
import { AgGridReact } from "ag-grid-react";
import { fetchInvoices } from "./FinancialCardUpdate";
import {
  getAllSalesOrder,
  deleteErpService,
  UpdateserviceListRow,
} from "./ERPActions/erpActions";
import AddServiceCard from "./AddServiceCard";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import { doctorActions } from "../../core/actions";
import { useOrganization } from "../../configurations/OrganizationContext";
import {
  ERP_LOCATION_MAP_LOCATION_NAME,
  ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
  ERP_GENERATE_INVOICE_REQUEST,
  ERP_OUT_PATIENT_BILLING_LOC_NAME,
  ERP_LOCATION_NAME_TO_LOCATION_ID_MAP,
  ERP_IN_PATIENT_BILLING_LOC_NAME,
  ERP_CURRENCY_OBJ,
  ERP_BILLING_TYPE_SO,
  ERP_LABEL_INTERNAL_STATUS_BOOKED,
  PATIENT_VISIT_TYPE,
  AG_GRID_REACT_MIN_ROW_HEIGHT,
  COMPONENT_WISE_AG_GRID_PAGINATION_SIZE,
  COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT,
  MASTER_LOCATION_DATA_LOCATION_KEY,
} from "../../core/constants/erpConstants";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box } from "@mui/material";
import { savePatientInvoice } from "./ERPActions/erpActions";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import patientActions from "../../core/actions/patientActions";
import personDetailsService from "../../core/services/personDetailsService";
import { helperServices } from "../../shared/helper";
import PatientEditForm from "../patient/PatientEditForm";
import {
  ERP_LABEL_MOVETOBILL,
  ERP_VISIT_FIN_SUMMARY_TYPE_SO,
} from "../../core/constants/erpConstants";
import Components from "..";
import { DataContext } from "./ERPBilling";
import { PROCEDURE_CONSTANTS_DETAILS } from "../../shared/constants";
import { update } from "lodash";

export default function ERPServicesList(props) {
  const org = useOrganization();
  const { searchInputRef } = props;
  const { prodcutSelected, setProductSelected } = useContext(DataContext);
  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic
  );
  const [doctorList, setDoctorList] = useState([]);
  const dispatch = useDispatch();
  const [addShow, setAddShow] = useState(false);
  const [addNewService, setAddNewService] = useState();
  const [selectedLocationDetail, setSelectedLocationDetail] = useState(
    props.selectedLocationDetails
  );
  const [patientId, setPatientId] = useState(props.patientId);
  const [visitId, setVisitId] = useState(props.visitId);
  const [rowData, setRowData] = useState([]);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [editamount, setEditAmount] = useState(addNewService?.price || 0);
  const [discountAmount, setDiscountAmount] = useState(() => {
    const original = Number(addNewService?.originalPrice) || 0;
    const price = Number(addNewService?.price) || 0;
    return original - price;
  });

  const [originalAmount, setOriginalAmount] = useState(
    addNewService?.updatedOriginalPrice || 0
  );
  const [doctor, setDoctor] = useState("");
  const gridRef = useRef();
  const financialSummaryRef = useRef(null);
  const skipNextFinancialReloadRef = useRef(false);
  const [onModel, setOnModal] = useState(false);
  const [invDetails, setInvDetails] = useState();
  const [isaddDisable, setIsaddDisable] = useState(false);
  const [gvId, setGvId] = useState(0);
  const initialServiceForm = {
    quantity: 1,
    originalAmount: 0,
    discountAmount: 0,
    editamount: 0,
    doctor: "",
  };
  const [serviceForm, setServiceForm] = useState(initialServiceForm);
  const [isServiceEdit, setIsServiceEdit] = useState(false);

  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails
  );
  const [openConfirm, setOpenConfirm] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);

  useEffect(() => {
    console.log("props data : ", props);
    getDoctorsList();
    fetchSalesOrder();
  }, []);

  useEffect(() => {
    dispatch(
      doctorActions.getAssignedDoctor(patientInfo, (resCb) => {
        setGvId(resCb.va.targetid);
      })
    );
    console.log("useffe rowdata: ", rowData);
    console.log("props.rowUpdate: ", props.rowUpdate);
    if (props.rowUpdate && props.rowUpdate.value !== "3") {
      setServiceForm((prev) => ({
        ...prev,
        doctor:
          props.rowUpdate?.productDetail?.gvId > 0
            ? props.rowUpdate.productDetail.gvId
            : gvId,
        originalAmount: props.rowUpdate.originalPrice,
        editamount: props.rowUpdate.price,
        discountAmount: props.rowUpdate.originalPrice - props.rowUpdate.price,
      }));
      // setEditAmount(props.rowUpdate.price);
      // setOriginalAmount(props.rowUpdate.originalPrice);
      setAddNewService(props.rowUpdate);
      setIsaddDisable(false);
    } else {
      setAddNewService(null);
    }
    setAddShow(true);
  }, [props.rowUpdate]);

  const extractFilters = (tagList) => {
    const textTag = tagList?.find((t) => t?.type === "text");
    const dateTag = tagList?.find((t) => t?.type === "date");

    return {
      searchQuery: textTag ? textTag.value : "",
      dateFrom: dateTag ? dateTag.from : "",
      dateTo: dateTag ? dateTag.to : "",
    };
  };

  useEffect(() => {
    if (skipNextFinancialReloadRef.current) {
      skipNextFinancialReloadRef.current = false;
      return;
    }

    console.log("props data : ", props);
    let locationDetail = props.selectedLocationDetails;
    let patientId = props.patientId;
    let visitId = props.visitId;
    let totlAdvancePaid = props.totalAdvPaid;
    const { start: fromDate, end: toDate } = props.dateRange || {};
    const { searchQuery } = extractFilters(props?.searchtags);
    let locationId = [];

    const hasAllLocationKey = locationDetail?.some(
      (element) => element?.locationDetails && element?.locationKey === "all",
    );

    if (hasAllLocationKey) {
      const matchingElement = locationDetail?.find(
        (element) => element?.locationKey === "all",
      );
      locationId =
        matchingElement?.locationDetails?.erpLocationDetails?.[0].locationid;
    } else {
      locationId = [
        ...new Set(
          locationDetail.map(
            (element) =>
              element?.locationDetails?.erpLocationDetails?.[0].locationid,
          ),
        ),
      ];
    }

    const clientERPCustId =
      locationDetail
        ?.map((el) => el?.clientERPCustId)
        .find((id) => id != null) ?? null;
    async function loadInvoices() {
      const result = await fetchInvoices({
        patientId,
        visitId,
        locationId,
        fromDate,
        toDate,
        searchQuery,
        clientERPCustId,
        totlAdvancePaid,
        props,
        masterLocationDetails,
        org,
      });

      financialSummaryRef.current = result.finSummary;
      props.onFinancialUpdate(result.finSummary);
    }
    loadInvoices();
  }, [rowData]);

  const fetchSalesOrder = async (shouldShowAdd = true) => {
    try {
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${selectedLocationDetail}`
      );

      let locDetail = selectedLocationDetail;
      let loc = [];

      // Check if any element in selectedLocationDetail meets the condition
      const hasAllLocationKey = locDetail?.some(
        (element) =>
          element?.locationDetails && element?.locationKey === "all"
      );

      if (hasAllLocationKey) {
        // Execute the if clause when a matching element is found
        const matchingElement = locDetail?.find(
          (element) => element?.locationKey === "all"
        );
        loc = matchingElement?.locationDetails?.erpLocationDetails?.[0].locationid;
      } else {
         loc = await helperServices.getLocationIdByvisitType(
          masterLocationDetails,
          patientInfo.visit.type,
        );
      }
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${loc}`
      );

      // if(loc && loc.length>0){
      const response = await getAllSalesOrder(patientId, visitId, loc);
      let updatedRows = null;
      if (response) {
        console.log("getAllSalesOrder : response : ", response);
        updatedRows = getAllRowData(response.serviceList);
      }
      // }

      const addRow = props.rowUpdate;
      console.log("adrow: ", addRow);

      if (addRow && addRow.value !== "3") {
        //setAddNewService(...addRow);
        setAddNewService(addNewService ? { ...addRow } : addRow);
        // addRowData(addRow);
        setAddShow(shouldShowAdd);
      }
      // else {
      // }
      return updatedRows;
    } catch (error) {
      console.error("Error fetching sales order:", error);
      // You might want to add error handling here, such as setting an error state
      return [];
    }
  };

  const getDoctorsList = (data) => {
    const doctorsDetail = personDetailsService.getDoctorsDetail();
    //console.log("doctorList in visittype",doctorsDetail);
    //dispatch(doctorActions.getDoctorList(data,resCb=>{
    //if(resCb){
    let list = [];
    for (let doc of doctorsDetail) {
      let opt = {};
      if (doc != null) {
        if (!doc.first_name) {
          doc.first_name = "";
        }
        if (!doc.last_name) {
          doc.last_name = "";
        }
        // opt['id'] = doc.personId
        opt["id"] = doc.gvId;
        opt["type"] = doc.type;
        const name = helperServices.getFullName(
          doc.first_name,
          null,
          doc.last_name
        );
        opt["role"] = doc.role;
        opt["value"] = doc.email;
        opt["department"] = doc.department;
        opt["firstName"] = doc.first_name;
        opt["lastName"] = doc.last_name;
        opt["label"] =
          doc.displaytitle +
          "." +
          " " +
          name +
          ", " +
          "Dep of " +
          doc.department +
          " (" +
          doc.qualification +
          " )";

        list.push(opt);
        // if(props.patientData.person && props.patientData.person.personId==doc.personId){
        //   setselectedDoctor(opt['label']);

        // }

        //console.log("list doctor Response:", list)
      }
    }
    //   list = list.filter((item) =>
    //     item?.type?.toLowerCase() === props?.type?.toLowerCase()
    //     );
    setDoctorList([...list]);

    // }
    //}))
  };

  const handleCellEdit = (params) => {
    const updatedRow = params.data;
    const column = params.colDef.field;
    const newValue = params.newValue;
    const oldValue = params.oldValue;

    if (newValue !== oldValue) {
      console.log("Edited field:", column);
      console.log("Old value:", oldValue);
      console.log("New value:", newValue);
      console.log("Updated row:", updatedRow);
    }
    handleEditCell(updatedRow, column);
  };

  const handleEditCell = (updatedRow, column) => {
    console.log("Edit clicked for row:", updatedRow, column);
    if (column == "amount" || column == "quantity") {
      let procedure = {
        patientId: patientId,
        visitId: visitId,
        billAmount: updatedRow.amount,
        quantity: updatedRow.quantity,
      };
      UpdateserviceListRow(
        patientId,
        visitId,
        selectedLocationDetail,
        procedure,
        (resCb) => {
          if (resCb) {
            console.log("resCb proc add Response:", resCb);
            fetchSalesOrder(false);
          }
        }
      );
    }
  };
  const closeVisitCompleteModal = () => {
    console.log("Button clicked");
    setOnModal(false);
  };

  const handleGenerateInvoice = async (event) => {
    setOnModal(false);
    if (event != null && event !== undefined) {
      const updatedRows = await fetchSalesOrder();
      if (!updatedRows || updatedRows.length === 0) {
        return;
      }
      const visitType = props?.selectedPatient?.visit?.type;
      // const targetName =
      //   visitType === "InPatient"
      //     ? ERP_PATIENT_VISIT_TYPE_IN_PATIENT
      //     : visitType === "OutPatient"
      //     ? ERP_PATIENT_VISIT_TYPE_OUT_PATIENT
      //     : "";
      let loc =
        visitType === "InPatient" ? 0 : visitType === "OutPatient" ? 4 : "";

      // setLocationId(loc);
      console.log("Delete clicked for row: ", props.data, event, rowData);
      console.log("Delete clicked for row: ");
      const SoList = {
        ...updatedRows,
        dataType: ERP_LABEL_MOVETOBILL,
        type: ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      };
      console.log("data productSelected: ", SoList);
      //below line is to update the solist in the new invoice tab
      getPatientProfile();
      setProductSelected(SoList);
      //below line to genarate the invoice direaclty from the sales order
      // let rowList = [];
      // Object.keys(rowData).forEach((key) => {
      //   if (!isNaN(key)) {
      //     const lineItem = rowData[key];
      //     const cleanedAmount =
      //       parseFloat(
      //         (lineItem.amount || "").toString().replace(/[₹,\s]/g, "")
      //       ) || 0;

      //     // Clone lineItem and clean amount in productDetail
      //     const cleanedProductDetail = {
      //       ...lineItem,
      //       amount: cleanedAmount,
      //       price: cleanedAmount,
      //     };

      //     const newRow = {
      //       date: "",
      //       slNo: lineItem.soLinID,
      //       soLineId: lineItem.soLinID,
      //       soId: lineItem.soId,
      //       serviceName: lineItem.productName,
      //       charges: cleanedAmount,
      //       quantity: lineItem.quantity,
      //       price: cleanedAmount,
      //       type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
      //       productDetail: cleanedProductDetail, // 👈 Cleaned here!
      //       prodId: lineItem.prodId,
      //       action: "delete",
      //     };

      //     rowList.push(newRow);
      //   }
      // });
      // generateInvoice(rowList);
    }
  };
  const getPatientProfile = () => {
    let patId = patientId;
    let visId = visitId;
    dispatch(
      patientActions.getPatientProfile(patId, visId,(resCb) => {
        if (resCb) {
          console.log("patientprofile", resCb);
        }
      })
    );
  };

  const generateInvoice = async (rowList) => {
    // rowData
    let invoiceItemList = [];
    const invDetail = await convertMoveSoToInvDetails(rowList);
    console.log("generateInvoice: inv detail :: ", invDetail);
    if (
      rowData &&
      rowData.length > 0 &&
      invDetail.loc !== null &&
      invDetail.loc !== undefined
    ) {
      const invResp = await savePatientInvoice(
        invDetail.loc,
        invDetail.invoiceDetail
      );
      if (invResp) {
        console.log("invResp : ", invResp);
        closeNewInvoice();
      }
    }
  };

  const closeNewInvoice = () => {
    setRowData(...[]);
    props.closeNewInvoice("2");
  };

  const convertMoveSoToInvDetails = async (rowData) => {
    const currentDate = new Date();
    console.log("current Date: ", currentDate);

    let invoiceDetail = ERP_GENERATE_INVOICE_REQUEST;
    // let loc = "";
    const visitType = props?.visitList?.visit?.type;
    let loc =
      visitType === "InPatient" ? 0 : visitType === "OutPatient" ? 4 : "";
    if (rowData && rowData.length > 0) {
      invoiceDetail.billNo = null;
      invoiceDetail.type = ERP_BILLING_TYPE_SO;
      invoiceDetail.date = `${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()}`;
      invoiceDetail.refund = false;
      invoiceDetail.m_sUser = "Support";
      invoiceDetail.patientId = patientId;
      invoiceDetail.visitId = visitId;
      invoiceDetail.invoiceLineItem = rowData;
      invoiceDetail.date = currentDate;
      invoiceDetail.erpCustId = props.visitList.erpCustId;
      invoiceDetail.invoicePayments = "";
      let patientFullName = "";
      if (
        props.visitList.fname &&
        props.visitList.mname &&
        props.visitList.lname
      ) {
        patientFullName =
          props.visitList.fname +
          " " +
          props.visitList.mname +
          " " +
          props.visitList.lname;
      } else {
        patientFullName = props.visitList.fname + " " + props.visitList.lname;
      }
      invoiceDetail.m_sCustomerName = patientFullName;
      invoiceDetail.customerId = props.visitList.erpCustId;
      invoiceDetail.billType = "SL";
      invoiceDetail.location = loc;
      invoiceDetail.salesperson = "Support";
      invoiceDetail.narration = "";
      invoiceDetail.custome1 = visitId;
      invoiceDetail.custome2 = "";
      invoiceDetail.custome3 = "";
      invoiceDetail.discountRs = 0.0;
      invoiceDetail.discountPerc = 0.0;
      invoiceDetail.custome4 = "Custom field 4";
      invoiceDetail.roundOffQaulifier = "ROUND_OFF";
      invoiceDetail.narration1 = "";
      invoiceDetail.mrpInvoice = false;
      invoiceDetail.shippedAddress = "";
      invoiceDetail.currencyId = ERP_CURRENCY_OBJ.id;
      invoiceDetail.m_aLines = [];
      invoiceDetail.invoicePayments = [];
      invoiceDetail.m_dDate = currentDate; //`${currentDate.getDate()}-${currentDate.getMonth()}-${currentDate.getFullYear()}`,

      let invoiceTotalAmount = 0.0;
      let invLineItemList = [];
      // ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE
      await rowData.forEach((row) => {
        let invItem = {
          m_iTicketLine: row.slNo,
          m_sProdRef: row.prodId,
          m_sProdName: row.serviceName,
          m_dMultiply: row.quantity,
          m_dPrice: row?.productDetail?.sellprice,
          salesOrderId: row.soId,
          m_TaxInfo: {
            m_iID: row?.productDetail?.taxid,
            m_dRate: row?.productDetail?.taxRate,
          },
          m_dPriceBuy: row?.productDetail?.buyPrice,
          sellPriceIncTax: row?.productDetail?.sellPricetax,
          uomId: row?.productDetail?.uomid ? row.productDetail.uomid : null,
          m_discount_line: 0.0,
          varientId: row?.productDetail?.varientId,
          batchNo: row?.productDetail?.batchNo,
          type1: row?.productDetail?.type1,
          type2: row?.productDetail?.type2,
          type3: row?.productDetail?.type3,
          type4: row?.productDetail?.type4,
          sizeId: row?.productDetail?.sizeId,
          mrp: row?.productDetail?.sellPricetax,
          m_doriginalPriceSell: row?.productDetail?.sellprice,
          trackInventory: row?.productDetail?.trackinventory,
        };
        invoiceTotalAmount += row.quantity * row.charges;
        invLineItemList.push(invItem);
      });
      let invPaymentDetail = [
        {
          total: invoiceTotalAmount,
          name: "paperin",
        },
      ];
      invoiceDetail.invoiceTotalAmount = invoiceTotalAmount;
      invoiceDetail.m_aLines = invLineItemList;
      invoiceDetail.invoicePayments = invPaymentDetail;
      invoiceDetail.totalInvoiceAmount = invoiceTotalAmount;
    }

    // if (
    //   ERP_PATIENT_VISIT_TYPE_OUT_PATIENT.toLowerCase() ===
    //   props.visitList.visit.type.toLowerCase()
    // ) {
    //   loc =
    //     ERP_LOCATION_NAME_TO_LOCATION_ID_MAP[
    //       ERP_PATIENT_VISIT_TYPE_OUT_PATIENT
    //     ];
    // } else {
    //   loc =
    //     ERP_LOCATION_NAME_TO_LOCATION_ID_MAP[ERP_PATIENT_VISIT_TYPE_IN_PATIENT];
    // }
    loc = loc;
    const invPopulateObj = {
      loc: loc,
      invoiceDetail: invoiceDetail,
    };
    setInvDetails(invPopulateObj);
    return invPopulateObj;
  };

  const addService = async (service) => {
    console.log("add_service : ", service);
    let procedure = {
      patientId: patientId,
      visitId: visitId,
      categoryId: service.productDetail.packageid,
      categoryServiceId: service.productDetail.packageServiceId,
      quantity: service.quantity,
      packageService: service.productDetail,
      refGvId: service.doctor,
      notes: service.description,
      productId: service.prodId,
      billNumber: null,
      billAmount: service.editamount,
      originalServicePrice:service.originalPrice,
      billDate: null,
      groupname: PROCEDURE_CONSTANTS_DETAILS.PROCEDURE_GROUPNAME_INVOICE,
      subgroup: PROCEDURE_CONSTANTS_DETAILS.PROCEDURE_SUBGROUP_SO,
      compositionId: null,
      billtype: "self",
      billable: service.billable,
    };
    if (!service.typePackage) {
      procedure["originalServicePrice"] = service.originalAmount;
    }

    console.log("add proc start", procedure);
    return new Promise((resolve, reject) => {
      dispatch(
        doctorActions.addProcedure(procedure, (resCb) => {
          try {
            if (resCb) {
              console.log("resCb proc add Response:", resCb);
              setAddNewService("");
              setServiceForm(initialServiceForm);
              setAddShow(false);
              if (resCb.successMessages) {
                props.serverResposnes("service added successfully", "success");
              } else {
                props.serverResposnes("service Add failed", "error");
              }
              props.clearProps(true);
              resolve(resCb);
            } else {
              reject(new Error("Empty response from addProcedure"));
            }
          } catch (err) {
            reject(err);
          }
        })
      );
    });
  };

  function getAllRowData(serviceList) {
    let uRowData = [];
    console.log("get all row i/p data : ", serviceList);

    if (serviceList != null) {
      serviceList.forEach((service) => {
        // soData.salesOrderLineItems.forEach((soLineOrderItems) => {
        // let amount = soLineOrderItems.price * soLineOrderItems.units;
        let row = {
          soId: service.soId,
          serviceName: service.productName,
          prodId: service.prodId,
          productName: service.productName,
          description: service.description,
          originalPrice: service.originalPrice,
          updatedOriginalPrice: service.originalPrice,
          quantity: service.quantity,
          amount: service.amount,
          price: service.amount,
          location: helperServices.getFirstLocationNameByLocationId(masterLocationDetails, service.locationId),
          locationId: service.locationId,
          voucherList: "",
          doctor: "",
          action: "",
          soLinID: service.salesLineId,
          patientId:service.patientId,
          visitId:service.visitId,
        };
        uRowData.push(row);
        // });
        console.log("salesOrder : ", service);
      });
    }
    setRowData(uRowData);
    return uRowData;
  }

  const defaultColDef = useMemo(() => {
    return {
      // flex: 1,
      //   justifyContent: 'center',
      //   flex: 1,
      //   minWidth: 100,
      editable: true,
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      //   borderRight: 'black 1px',
    };
  }, []);

  const useVoucherListEditor = (props) => {
    const [value, setValue] = useState(props.value);

    const onValueChange = (event) => {
      setValue(event.target.value);
      props.setValue(event.target.value);
    };

    return (
      // {props.type == Edit?
      <select
        value={value}
        onChange={onValueChange}
        // style={{ width: '80%', height: '70%', padding: '4px', margin: '4px' }}
      >
        <option value=""></option>
      </select>
      // }
    );
  };

  const voucherListRenderer = (params) => {
    const color = params.value;
    return (
      <div
        style={{
          backgroundColor: color,
          color: color === "black" ? "white" : "black",
          // padding: '4px',
          borderRadius: "4px",
          textAlign: "center",
        }}
      >
        {color.charAt(0).toUpperCase() + color.slice(1)}
      </div>
    );
  };

  // First, create an ActionRenderer component at the top of your file, after the imports
  const ActionRenderer = (props) => {
    // const handleEdit = () => {
    //   console.log("Edit clicked for row:", props.data);
      
    // };

      // const handleEdit = (e) => {
      //     console.log("Edit clicked for row:", props.data);
      //     console.log("Eventtttt", e);
      //       let row = { ...props.data };
      //       if (!row.productDetail) {
      //     row.productDetail = {
      //       productId: row.prodId,
      //       productName: row.productName || row.serviceName,
      //       description: row.description,
      //       sellprice: row.price,
      //       amount: row.price,
      //       billable: true,
      //       soId : row.soId,
      //       soLinID: row.soLinID,
      //       patientId: row.patientId,
      //       visitId: row.visitId,
      //       locationId: row.locationid,
      //       location: row.location,
      //       price: row.price,
      //       serviceName: row.serviceName,
      //       updatedOriginalPrice: row.updatedOriginalPrice,
      //       packageServiceProduct: [
      //         { productId: row.prodId, productName: row.productName || row.serviceName }
      //       ]
      //     };
      //     }
      //     setServiceForm({
      //       originalAmount: row.originalPrice ?? row.amount,
      //       discountAmount: (row.originalPrice ?? row.amount) - row.price,
      //       editamount: row.originalPrice ?? row.amount ?? row.price,
      //       quantity: row.quantity ?? 1
      //     });
           
      //     setAddNewService(row);
      //     setAddShow(true);
      //     setIsServiceEdit(true);
      //   };

      const handleEdit = (e) => {
  console.log("Edit clicked for row:", props.data);
  const row = { ...props.data };

  // Build productDetail if missing
  if (!row.productDetail) {
    row.productDetail = {
      productId: row.prodId,
      productName: row.productName || row.serviceName,
      description: row.description,
      sellprice: row.price,
      amount: row.price,
      billable: true,
      soId: row.soId,
      soLinID: row.soLinID,
      patientId: patientId,
      visitId: visitId,
      locationId: row.locationid,
      location: row.location,
      price: row.price,
      serviceName: row.serviceName,
      updatedOriginalPrice: row.updatedOriginalPrice,
      packageServiceProduct: [
        { productId: row.prodId, productName: row.productName || row.serviceName }
      ]
    };
  }

  // --- FIXED PRICE LOGIC ---
  const originalAmount =
    row.originalPrice ??
    row.updatedOriginalPrice ??
    row.productDetail.updatedOriginalPrice ??
    row.price;

  const editamount =
    row.billAmount ??
    row.amount ??
    row.price;

  const discountAmount = originalAmount - editamount;

  // --- SET FORM VALUES CORRECTLY ---
  setServiceForm({
    originalAmount,
    editamount,
    discountAmount,
    quantity: row.quantity ?? 1,
    doctor: row.gvid || ""
  });

  setAddNewService(row);
  setAddShow(true);
  setIsServiceEdit(true);
};


    const handleDelete = async () => {
      console.log("Delete clicked for row:", props.data);
      console.log("patientId", patientId, visitId);

      const { soId, soLinID } = props.data;

      try {
        const resCb = await deleteErpService(patientId, visitId, soId, soLinID);

        if (resCb) {
          console.log("resCb proc add Response:", resCb);
          fetchSalesOrder(false);
        }
      } catch (err) {
        console.error("Failed to delete:", err);
      }

      console.log("deleted procedure");
    };

    const handleMoreOptions = () => {
      console.log("Delete clicked for row:", props.data);
      // Add your delete logic here
    };
    const openDeleteDialog = () => {
      setPendingDelete(() => handleDelete);
      setOpenConfirm(true);
    };

    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
         <a title="Edit">
          <i
            className="material-icons mr-1"
            // style={{ marginLeft: `10px` }}
            onClick={(event) => handleEdit(event)}
          >
            edit
          </i>
        </a> 

        <a title="Delete">
          <i
            className="material-icons mr-1"
            style={{ color: "#a32424" }}
            onClick={openDeleteDialog}
          >
            delete
          </i>
        </a>

        {/* <a title="More Options">
          <i
            className="material-icons mr-1"
            style={{ color: "#000" }}
            onClick={(event) => handleMoreOptions(event)}
          >
            more_vert
          </i>
        </a> */}
      </div>
    );
  };

  const columnDefs = [
    // {
    //     headerCheckboxSelection: true,
    //     checkboxSelection: true,
    //     headerName: '',
    //     field: 'checkbox',
    //     flex: .4,
    //     tooltipField: "Checkbox",
    // },
    // {
    //   headerName: "SO ID",
    //   field: "soId",
    //   editable: true,
    //   sortable: true,
    //   filter: true,
    //   resizable: true,
    //   floatingFilter: true,
    //   flex: 1,
    //   // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
    //   //cellClass: ["ag-cell-center", "table-head"],
    //   tooltipField: "SO ID",
    // },
    // {
    //   headerName: "Service Name",
    //   field: "serviceName",
    //   editable: true,
    //   sortable: true,
    //   filter: true,
    //   resizable: true,
    //   floatingFilter: true,
    //   flex: 1,
    //   // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
    //   //cellClass: ["ag-cell-center", "table-head"],
    //   tooltipField: "Service Name",
    // },
    // {
    //   headerName: "Location Name",
    //   field: "location",
    //   // editable: true,
    //   sortable: true,
    //   filter: true,
    //   resizable: true,
    //   floatingFilter: true,
    //   filter: "agNumberColumnFilter",
    //   flex: 1,
    //   // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
    //   //cellClass: ["ag-cell-center", "table-head"],
    //   tooltipField: "Service Name",
    // },
    // {
    //     headerName: 'Product Name',
    //     field: 'productName',
    //     editable: true,
    //     sortable: true,
    //     filter: true,
    //     resizable: true,
    //     floatingFilter: true,
    //     flex: 1,
    //     // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
    //     //cellClass: ["ag-cell-center", "table-head"],
    //     tooltipField: "Product Name",
    // },
    {
      headerName: "Service Description",
      field: "description",
      // editable: true,
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      flex: 2,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
      tooltipField: "Description",
    },
    {
      headerName: "Original Charges /per unit",
      field: "originalPrice",
      // editable: true,
      sortable: true,
      // valueFormatter: (params) => `₹ ${params.value}`,
      valueFormatter: (params) => `₹ ${Number(params.value).toFixed(2)}`,
      filter: true,
      resizable: true,
      floatingFilter: true,
      flex: 1,
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
      tooltipField: "Original Price per unit with tax",
    },
    // {
    //   headerName: "Discounted Charges/per unit",
    //   field: "amount",
    //   // editable: true,
    //   sortable: true,
    //   valueFormatter: (params) => `₹ ${params.value !== 'undefined' ? params.value : 0}`,
    //   filter: true,
    //   resizable: true,
    //   floatingFilter: true,
    //   flex: 1,
    //   cellStyle: { textAlign: 'right', },
    //   // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
    //   tooltipField: "Amount",
    // },
    {
      headerName: "Discount Charges/per unit",
      field: "discountCharges",
      sortable: true,
      valueGetter: (params) => {
        const original = params.data.originalPrice || 0;
        const amount = params.data.amount || 0;
        const discount = original - amount;
        return Number(discount.toFixed(2));
      },
      valueFormatter: (params) => `₹ ${Number(params.value).toFixed(2)}`,
      filter: true,
      resizable: true,
      floatingFilter: true,
      flex: 1,
      cellStyle: { textAlign: "right" },
      tooltipField: "discount amount",
    },
    {
      headerName: "Quantity",
      field: "quantity",
      // editable: true,
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      flex: 0.5,
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
      tooltipField: "Quantity",
    },
    {
      headerName: "Amount",
      // field: "amount",
      // editable: true,
      sortable: true,
      // valueFormatter: (params) => `₹ ${params.value}`,
      valueFormatter: (params) => `₹ ${Number(params.value).toFixed(2)}`,
      valueGetter: "data.amount * data.quantity",
      filter: true,
      resizable: true,
      floatingFilter: true,
      flex: 1,
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
      tooltipField: "Amount",
    },
    // {
    //     headerName: 'Voucher List',
    //     field: 'voucherList',
    //     editable: true,
    //     sortable: true,
    //     filter: true,
    //     resizable: true,
    //     floatingFilter: true,
    //     flex: 1,
    //     // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
    //     // editable: true,
    //     // cellEditor: "useVoucherListEditor",
    //     cellRenderer: "useVoucherListEditor",
    //     tooltipField: "Voucher List",
    // },
    // {
    //     headerName: 'Doctor',
    //     field: 'doctor',
    //     editable: true,
    //     sortable: true,
    //     filter: true,
    //     resizable: true,
    //     floatingFilter: true,
    //     flex: 1,
    //     // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
    //     tooltipField: "Doctor",
    // },
    {
      headerName: "Action",
      field: "action",
      flex: 1,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer'},
      cellRenderer: "ActionRenderer",
      tooltipField: "Action",
    },
  ];

  let currentRowHeight;

  const updateRowHeight = (params) => {
    // get the height of the grid body - this excludes the height of the headers
    const bodyViewport = document.querySelector(".ag-body-viewport");
    if (!bodyViewport) {
      return;
    }
    const gridHeight = bodyViewport.clientHeight;
    // get the rendered rows
    const renderedRowCount = params.api.getDisplayedRowCount();
    // if the rendered rows * min height is greater than available height, just just set the height
    // to the min and let the scrollbar do its thing
    if (renderedRowCount * AG_GRID_REACT_MIN_ROW_HEIGHT >= gridHeight) {
      if (currentRowHeight !== AG_GRID_REACT_MIN_ROW_HEIGHT) {
        currentRowHeight = AG_GRID_REACT_MIN_ROW_HEIGHT;
        params.api.resetRowHeights();
      }
    } else {
      // set the height of the row to the grid height / number of rows available
      currentRowHeight = Math.floor(gridHeight / renderedRowCount);
      params.api.resetRowHeights();
    }
  };

  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);
  const getRowHeight = useCallback((params) => {
    return currentRowHeight;
  }, []);

  const onFirstDataRendered = useCallback(
    (params) => {
      updateRowHeight(params);
    },
    [updateRowHeight]
  );

  const onGridSizeChanged = useCallback(
    (params) => {
      updateRowHeight(params);
    },
    [updateRowHeight]
  );

  const containerStyle = useMemo(
    () => ({
      width: "100%",
      height: COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT.ERPServicesList,
    }),
    []
  );
  const gridStyle = useMemo(
    () => ({ alignItems: "start", height: "100%", width: "100%" }),
    []
  );
  const rowStyle = {
    background: "white",
    display: "flex",
    justifyContent: "center",
    BorderBottom: "1px solid #D0D0D0",
  };

  // const gridStyle = {
  //     // height: '100%',

  //     width: '100%',
  //     border: '1px solid lightgray', // For table border
  // };

  // set background colour on every row

  const handleAdd = async (event) => {
    try {
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }
      setIsaddDisable(true);
      const updated = {
        ...addNewService,
        ...serviceForm,
      };
      if (updated.typePackage) {
        console.log("package valuee",updated);
        
        for (const uService of updated.serviceList) {
          uService.quantity = serviceForm.quantity;
          const totalPrice = serviceForm.originalAmount;
          if (totalPrice > 0) {
            if(updated.originalPrice===totalPrice){

            const weight = (uService.originalPrice || 0) / totalPrice;
            console.log(weight,"weightttttt");
            const discountForThisService =
              weight * (serviceForm.discountAmount || 0);
              //  console.log(discountForThisService,"discountForThisService");
            const newCharges = (uService.originalPrice || 0) - discountForThisService;
            uService.originalAmount=(uService.originalPrice || 0);
            uService.editamount = Number(newCharges.toFixed(2));
            }else{
              const weight = (uService.originalPrice || 0) / totalPrice;
              //  console.log(discountForThisService,"discountForThisService");
              const uWeight = totalPrice / (uService.originalPrice || 0);
              const discountForThisService = uWeight * (serviceForm.discountAmount || 0);
            const newCharges = ((uService.originalPrice || 0) - discountForThisService)*uWeight;
             uService.originalAmount=(uService.originalPrice || 0)*uWeight;
            uService.editamount = Number(newCharges.toFixed(2));
            }
           
          }
          await addService(uService);
        }
      } else {
        await addService(updated);
      }
      setServiceForm(initialServiceForm);
    } finally {
      fetchSalesOrder(false);
      setIsaddDisable(false);
    }
  };

  const handleEditSuccess = async () => {
    const editedSoId = addNewService.soId;
    const editedSoLineId = addNewService.soLinID;
    const oldRow = rowData.find(
      (row) => row.soId === editedSoId && row.soLinID === editedSoLineId
    );

    if (!oldRow) {
      await fetchSalesOrder(false);
      return;
    }

    const newQuantity = Number(serviceForm.quantity) || 0;
    const newAmount = Number(serviceForm.editamount) || 0;
    const newOriginalPrice = Number(serviceForm.originalAmount) || 0;
    const oldQuantity = Number(oldRow.quantity) || 0;
    const oldAmount = Number(oldRow.amount) || 0;
    const oldOriginalPrice = Number(oldRow.originalPrice) || 0;

    const billDelta = newQuantity * newAmount - oldQuantity * oldAmount;
    const grossDelta =
      newQuantity * newOriginalPrice - oldQuantity * oldOriginalPrice;
    const discountDelta = grossDelta - billDelta;

    skipNextFinancialReloadRef.current = true;
    setRowData((currentRows) =>
      currentRows.map((row) =>
        row.soId === editedSoId && row.soLinID === editedSoLineId
          ? {
              ...row,
              quantity: newQuantity,
              amount: newAmount,
              price: newAmount,
              originalPrice: newOriginalPrice,
              updatedOriginalPrice: newOriginalPrice,
            }
          : row
      )
    );

    const currentSummary = financialSummaryRef.current;
    if (currentSummary?.all) {
      const updatedSummary = {
        ...currentSummary,
        all: {
          ...currentSummary.all,
          totalBillAmount: currentSummary.all.totalBillAmount + billDelta,
          totalGrossAmount: currentSummary.all.totalGrossAmount + grossDelta,
          totalDiscountAmount:
            currentSummary.all.totalDiscountAmount + discountDelta,
          totalSalesOrderAmt:
            currentSummary.all.totalSalesOrderAmt + billDelta,
        },
      };

      const locationSummary = currentSummary[oldRow.locationId];
      if (locationSummary) {
        updatedSummary[oldRow.locationId] = {
          ...locationSummary,
          totalBillAmount: locationSummary.totalBillAmount + billDelta,
          totalGrossAmount: locationSummary.totalGrossAmount + grossDelta,
          totalDiscountAmount:
            locationSummary.totalDiscountAmount + discountDelta,
          totalSalesOrderAmt: locationSummary.totalSalesOrderAmt + billDelta,
        };
      }

      financialSummaryRef.current = updatedSummary;
      props.onFinancialUpdate(updatedSummary);
    }
  };

  const handleCancelAdd = () => {
    setDoctor("");
    props.clearProps(true);
    setIsServiceEdit(false);
    setServiceForm(initialServiceForm);
      setAddShow(false);       
      setAddNewService(null);  
      setServiceForm({});     
      setIsServiceEdit(false); 
    console.log("addservice after cancel", addNewService, rowData);
  };

  const moveToBill = () => {
    setOnModal(true);
  };

  return (
    <>
      <div>
        {console.log("addnewservice", addNewService)}
        {addShow && addNewService && addNewService.productDetail && (
          <AddServiceCard
            addShow={addShow}
            addNewService={addNewService}
            setAddNewService={setAddNewService}
            serviceForm={serviceForm}
            setServiceForm={setServiceForm}
            doctorList={doctorList}
            handleAdd={handleAdd}
            handleCancelAdd={handleCancelAdd}
            handleEditSuccess={handleEditSuccess}
            isaddDisable={isaddDisable}
            isServiceEdit={isServiceEdit}
          />
        )}
      </div>
      {/* <> */}
      <div className="ms-1" style={containerStyle}>
        {/* <div className='ag-theme-balham ag-style p-2 m-3 w-100' style={gridStyle}> */}
        <div className="ag-theme-balham ag-style ag-header-left px-1 py-2 w-100 h-100">
          <AgGridReact
            // autoSizeStrategy={autoSizeStrategy}
            // getRowHeight={getRowHeight}
            // onGridReady={onGridReady}
            // onFirstDataRendered={onFirstDataRendered}
            // onGridSizeChanged={onGridSizeChanged}
            // theme={theme}
            rowData={rowData}
            // rowStyle={rowStyle}
            pagination={COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPServicesList}
            paginationPageSize={
              COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPServicesList
            }
            columnDefs={columnDefs}
            // isExternalFilterPresent={isExternalFilterPresent}
            // doesExternalFilterPass={doesExternalFilterPass}
            rowSelection="multiple"
            suppressRowClickSelection
            frameworkComponents={{
              ActionRenderer: ActionRenderer,
              useVoucherListEditor: useVoucherListEditor,
            }}
            onCellValueChanged={handleCellEdit}
            suppressHeaderKeyboardEvent={() => true} // disables all keyboard events on headers
            // defaultColDef={defaultColDef}
            // animateRows={true}
            // className='d-flex justify-content-center'
          />
        </div>
      </div>
      {/* <div className="d-flex justify-content-end d-grid gap-3">
        <Button
          className="p-2 my-2 bg-primary text-white"
          variant="generateInvoice"
          onClick={moveToBill}
        >
          {ERP_LABEL_MOVETOBILL}
        </Button>
      </div>
      {onModel ? (
        <Components.MoveToBilling
          visitList={props.visitList}
          open={onModel}
          onModalClose={(e) => handleGenerateInvoice(e)}
          handleModelclose={(e) => closeVisitCompleteModal()} // pass directly
        />
      ) : (
        ""
      )} */}

      <ConfirmDeleteDialog
        open={openConfirm}
        title="Delete Record"
        message="Are you sure you want to delete this record?"
        showReason={false}
        onCancel={() => setOpenConfirm(false)}
        onConfirm={async () => {
          if (pendingDelete) await pendingDelete();

          setOpenConfirm(false);
        }}
      />
    </>
  );
}
